import { render, staticRenderFns } from "./RejectTickets.vue?vue&type=template&id=72a85d5d"
import script from "./RejectTickets.vue?vue&type=script&lang=ts"
export * from "./RejectTickets.vue?vue&type=script&lang=ts"
import style0 from "./RejectTickets.vue?vue&type=style&index=0&id=72a85d5d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports